export default [
  {
    title: '¿Cómo se llama el cantante y líder de Arctic Monkeys?',
    badtext: 'Mal. Es Alex Turner',
    id: 1,
    options: [
      {
        id: 'a',
        text: 'Alex Tunick',
        correct: false
      },
      {
        id: 'b',
        text: 'Axel Burner',
        correct: false
      },
      {
        id: 'c',
        text: 'Alex Turner',
        correct: true
      },
      {
        id: 'd',
        text: 'Axel Gardne',
        correct: false
      },
    ]
  },
  {
    title: '¿De dónde proviene el nombre del festival?',
    badtext: 'Mal. Un capítulo de Los Tres Chiflados',
    id: 2,
    options: [
      {
        id: 'a',
        text: 'Un capítulo de Los Tres Chiflados',
        correct: true
      },
      {
        id: 'b',
        text: 'Una expresión griega',
        correct: false
      },
      {
        id: 'c',
        text: 'Un antiguo programa de televisión',
        correct: false
      },
      {
        id: 'd',
        text: 'Un festival circense del siglo XIX',
        correct: false
      },
    ]
  },
  {
    title: '¿Quién es el cerebro detrás del festival?',
    badtext: 'Mal. es Perry Farrell',
    id: 3,
    options: [
      {
        id: 'a',
        text: 'Terry Martel',
        correct: false
      },
      {
        id: 'b',
        text: 'Perry Farrell',
        correct: true
      },
      {
        id: 'c',
        text: 'Ted Pharrell',
        correct: false
      },
      {
        id: 'd',
        text: 'Billy Corgan',
        correct: false
      },
    ]
  },
  {
    title: '¿En qué país se organizó por primera vez una edición de Lollapalooza fuera de Estados Unidos?',
    badtext: 'Mal. Fue en Chile',
    id: 4,
    options: [
      {
        id: 'a',
        text: 'Argentina',
        correct: false
      },
      {
        id: 'b',
        text: 'Brasil',
        correct: false
      },
      {
        id: 'c',
        text: 'Francia',
        correct: false
      },
      {
        id: 'd',
        text: 'Chile',
        correct: true
      },
    ]
  },
  {
    title: '¿Cómo se llama la banda de Aldo “Macha” Asenjo que participará este año en Lollapalooza Chile?',
    badtext: 'Mal. Es La Floripondio',
    id: 5,
    options: [
      {
        id: 'a',
        text: 'Pulentos',
        correct: false
      },
      {
        id: 'b',
        text: 'Caetano, Moreno, Zeka & Tom Veloso',
        correct: false
      },
      {
        id: 'c',
        text: 'La Floripondio',
        correct: true
      },
      {
        id: 'd',
        text: 'Monsieur Periné',
        correct: false
      },
    ]
  },
  {
    title: '¿Cómo se llamó el primer disco de Foals?',
    badtext: 'Mal. Antidotes.',
    id: 6,
    options: [
      {
        id: 'a',
        text: 'What went down',
        correct: false
      },
      {
        id: 'b',
        text: 'Antidotes',
        correct: true
      },
      {
        id: 'c',
        text: 'Total Live Forever',
        correct: false
      },
      {
        id: 'd',
        text: 'Holy Fire',
        correct: false
      },
    ]
  },
  {
    title: '¿De qué ciudad son originarios los chilenos Adelaida?',
    badtext: 'Mal. Son de Valparaíso.',
    id: 7,
    options: [
      {
        id: 'a',
        text: 'Concepción',
        correct: false
      },
      {
        id: 'b',
        text: 'Santiago',
        correct: false
      },
      {
        id: 'c',
        text: 'Antofagasta',
        correct: false
      },
      {
        id: 'd',
        text: 'Valparaíso',
        correct: true
      },
    ]
  },
  {
    title: '¿Cuál es el nombre real de la cantante chilena Rubio?',
    badtext: 'Mal. Se llama Francisca Straube.',
    id: 8,
    options: [
      {
        id: 'a',
        text: 'Francisca Sfeir',
        correct: false
      },
      {
        id: 'b',
        text: 'Francisca Puertas',
        correct: false
      },
      {
        id: 'c',
        text: 'Francisca Hoffmann',
        correct: false
      },
      {
        id: 'd',
        text: 'Francisca Straube',
        correct: true
      },
    ]
  },
  {
    title: '¿En qué edición Wayne Coyne de The Flaming Lips se metió a una pelota transparente y se lanzó al público?',
    badtext: 'Mal. Fue en el 2011, antes de la presentación de 30 Seconds to Mars',
    id: 9,
    options: [
      {
        id: 'a',
        text: '2015, junto a Jack White',
        correct: false
      },
      {
        id: 'b',
        text: '2013, cuando vino Pearl Jam',
        correct: false
      },
      {
        id: 'c',
        text: '2011, antes de la presentación de 30 Seconds to Mars',
        correct: true
      },
      {
        id: 'd',
        text: '2017, horas después de Cage the Elephant',
        correct: false
      },
    ]
  },
  {
    title: '¿Cómo se llama la banda tropical en que Américo fue vocalista?',
    badtext: 'Mal. Fue en el Grupo Alegría.',
    id: 10,
    options: [
      {
        id: 'a',
        text: 'Amerikan Sound',
        correct: false
      },
      {
        id: 'b',
        text: 'Ráfaga',
        correct: false
      },
      {
        id: 'c',
        text: 'Grupo Alegría',
        correct: true
      },
      {
        id: 'd',
        text: 'Damas Gratis',
        correct: false
      },
    ]
  },
  {
    title: '¿Qué banda nacida de una serie animada se presentará en Kidzapalooza?',
    badtext: 'Mal. Pulentos',
    id: 11,
    options: [
      {
        id: 'a',
        text: '31 Minutos',
        correct: false
      },
      {
        id: 'b',
        text: 'Pulentos',
        correct: true
      },
      {
        id: 'c',
        text: 'Diego & Glot',
        correct: false
      },
      {
        id: 'd',
        text: 'Condorito',
        correct: false
      },
    ]
  }
]